export function updateAsideTranslation() {
  const imgTrans = document.getElementById("translations");

  if (!imgTrans) return;

  window.translationImages = JSON.parse(imgTrans.dataset.imgSrc);

  window.updateTranslationImage = function () {
    let theme = "light";
    if (typeof document.documentElement.dataset.theme !== "undefined") {
      theme = document.documentElement.dataset.theme;
    }

    let translationPicture = document.getElementById(
      "anatomicalParts-translation-image"
    );
    if (translationPicture !== null) {
      translationPicture.src = window.translationImages[theme];
    }
  };

  window.updateTranslationImage();
}

updateAsideTranslation();
